import { OneTrustActionTypes, OneTrustConsentModel, OneTrustStatus } from './oneTrustTypes';

type SetOneTrustStatusAction = {
    type: OneTrustActionTypes.ONE_TRUST_SET_STATUS;
    status: OneTrustStatus;
};

type SetOneTrustConsentModelAction = {
    type: OneTrustActionTypes.ONE_TRUST_SET_CONSENT_MODEL;
    consentModel: OneTrustConsentModel | null;
};

type ShowOneTrustBannerAction = {
    type: OneTrustActionTypes.ONE_TRUST_SHOW_BANNER;
};

type HideOneTrustBannerAction = {
    type: OneTrustActionTypes.ONE_TRUST_HIDE_BANNER;
};

export type OneTrustActions =
    | SetOneTrustStatusAction
    | SetOneTrustConsentModelAction
    | ShowOneTrustBannerAction
    | HideOneTrustBannerAction;

export const setOneTrustStatus = (status: OneTrustStatus): SetOneTrustStatusAction => ({
    type: OneTrustActionTypes.ONE_TRUST_SET_STATUS,
    status,
});

export const setOneTrustConsentModel = (consentModel: OneTrustConsentModel | null): SetOneTrustConsentModelAction => ({
    type: OneTrustActionTypes.ONE_TRUST_SET_CONSENT_MODEL,
    consentModel,
});

export const showOneTrustBanner = (): ShowOneTrustBannerAction => ({
    type: OneTrustActionTypes.ONE_TRUST_SHOW_BANNER,
});

export const hideOneTrustBanner = (): HideOneTrustBannerAction => ({
    type: OneTrustActionTypes.ONE_TRUST_HIDE_BANNER,
});
